import { COLORS, FONTS } from '@app/src/ui';
import styled from 'styled-components';

interface Props {
  color?: string;
  backgroundColor?: string;
  isResponsive?: boolean;
}

export const Wrapper = styled.div`
  z-index: 100;
  background: white;
  display: flex;
  justify-content: center;
  right: 0px;
  position: absolute;
  top: 9%;
  font-family: ${FONTS.ROBOTO};
  font-size: 13px;
  line-height: 42px;
  width: 152px;
  background: ${(props: Props) => props.backgroundColor && `${props.backgroundColor}`};
  color: ${(props: Props) => props.color ? `
    ${props.color}
  `:`
    ${COLORS.BLUE_LINK};
  `};
`;

export const Loading = styled.i`
  height: 17px;
  width: 17px;
  margin-left: 6px;
  svg {
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite
  }

  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;